import _ from 'underscore';
import Handlebars from 'handlebars';
import CollectionTable from '@/views/collection_table';
import DeploymentItemView from '@/views/product_deployment_item';
import DeploymentItemTemplate from '@/../templates/deployment-item-selectable.hbs';
import strings_common from 'amdi18n-loader!@/nls/common';
import strings_specific from 'amdi18n-loader!@/nls/dialogs';
    var strings = _.extend({}, strings_common, strings_specific);

    function is_right_type(deployment, type, product) {
        var dg = deployment.rel.get('devicegroup');
        var dp = deployment.rel.get('product');
        if ( !dg || !dg.type ) return false;
        if ( dp && dp.id === product.id ) {
            switch ( type ) {
                case 'development_devicegroup':
                    if (dg.type === 'pre_production_devicegroup' || dg.type === 'development_devicegroup' || dg.type === 'production_devicegroup') return true;
                    break;
                case 'dut_devicegroup':
                    if ((dg.type === 'pre_dut_devicegroup' || dg.type === 'dut_devicegroup')
                        && deployment.get('flagged') === true) return true;
                    break;
                case 'pre_dut_devicegroup':
                    if (dg.type === 'pre_dut_devicegroup' || dg.type === 'dut_devicegroup' || dg.type === 'development_devicegroup') return true;
                    break;
                case 'production_devicegroup':
                    if ((dg.type === 'pre_production_devicegroup' || dg.type === 'development_devicegroup' || dg.type === 'production_devicegroup') 
                        && deployment.get('flagged') === true) return true;
                    break;
                case 'pre_production_devicegroup':
                    if (dg.type === 'pre_production_devicegroup' || dg.type === 'development_devicegroup' || dg.type === 'production_devicegroup') return true;
                    break;
                case 'factoryfixture_devicegroup':
                    if ((dg.type === 'pre_factoryfixture_devicegroup' || dg.type === 'development_devicegroup' || dg.type === 'factoryfixture_devicegroup')
                        && deployment.get('flagged') === true) return true;
                    break;
                case 'pre_factoryfixture_devicegroup':
                    if (dg.type === 'pre_factoryfixture_devicegroup' || dg.type === 'development_devicegroup' || dg.type === 'factoryfixture_devicegroup') return true;
                    break;
            }
        }
        return false;
    }

    var deployment_list = CollectionTable.extend({
        constructor: function(options){
            options.columns = [
                {
                    name: strings.select,
                    class_name: 'select',
                },
                {
                    name: strings.saved_created_on,
                    class_name: 'created_at',
                    sortable: false,
                    sort_by: 'created_at',
                },
                {
                    name: strings.sha,
                    class_name: 'sha',
                    centered: false,
                },
                {
                    name: 'Device Group',
                    class_name: 'devicegroup',
                    centered: false
                },
                {
                    name: strings.creator,
                    class_name: 'deployed-by',
                    centered: false,
                }
            ];
            options.secondary_sort = 'sha';
            options.default_sort_desc = true;
            options.default_sort_column = 1;
            CollectionTable.apply(this, arguments);
        },
        childView: DeploymentItemView.extend({
            events: {
                'click': 'chooseItem'
            },
            template: Handlebars.compile(DeploymentItemTemplate),
            chooseItem: function () {
                this.$el.find('input[name=deployments-radio]').prop('checked', true);
                this.triggerMethod('choose:deployment', this.model);
            },
        }),
        childViewOptions: {
            show_deployed_to: true,
            can_view_code: true,
        },
        class_name: 'products-list',
        filter: function (deployment) {
            return is_right_type(deployment, this.options.type, this.options.product);
        }
    });

    export default deployment_list;




